import { createDateObject, } from '@/core';

export default function() {
	return {
		deviationNumber: null,
		date: createDateObject({ hasTime: false }),
		registeredDate: undefined,
		vendor: {},
		customer: {},
		customerFault: false,
		terminal: null,
		deviationType: {},
		deviationCause: {},
		status: { id: 10, no: 'Åpen', en: 'Open', },
		discoveredAt: null,
		discoveredBy: null,
		licencePlates: [],
		clerk: {},
		pictures: [],
		message: '',
		goodsType: {},
		cost: null,
		id: undefined,
		orderBindings: [],
		trip: {},
		tripId: null,
		actionType: undefined,
		actionDescription: undefined,
		actionDate: undefined,
	};
}